import type { ReactNode, ComponentProps } from 'react';

import { useId } from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { Input } from '@shared/components/ui/input';

import { FieldShell } from './field-shell';

type Props = Omit<ComponentProps<typeof Input>, 'name' | 'value' | 'onChange'> & {
  name: string;
  /** Zone de texte multi-lignes (`rows` lignes) */
  multiline?: boolean;
  rows?: number;
  label?: ReactNode;
  helperText?: ReactNode;
  containerClassName?: string;
};

export const RHFTextField = ({ name, label, helperText, containerClassName, multiline, rows, ...other }: Props) => {
  const { control } = useFormContext();
  const id = useId();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <FieldShell className={containerClassName} error={error?.message} helperText={helperText} id={id} label={label}>
          <Input {...field} aria-invalid={error ? true : undefined} id={id} value={field.value ?? ''} {...other} />
        </FieldShell>
      )}
    />
  );
};
